import React from 'react'
import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import banner from '../../../Assets/images/location/main-banner-rochester.png'
import store from '../../../Assets/images/location/rochester-location.png'
import visit from '../../../Assets/images/location/location-banner-footer-1.png'
import visit1 from '../../../Assets/images/location/rochester-footer-21.png'
import visit2 from '../../../Assets/images/location/rochester-footer-22.png'
import visit3 from '../../../Assets/images/location/rochester-footer-23.png'
import contact from '../../../Assets/images/location/contact-us-rochester-pg.png'
import Pin from '../../../Assets/images/location/location-icon-pages.png'
import '../../../Assets/css/location.css'
import { useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';
const Index = () => {
    const pathname = window.location.pathname;
    const pathSegments = pathname.split('/').filter(segment => segment);
    const location = pathSegments[pathSegments.length - 1];
    const metaData = useSelector((state) => state?.persistedReducer?.meta?.meta);
    const storeLocation = useSelector(state => state.persistedReducer.home.store_locations)
    const location1 = location.replace(/%20/g, ' ')
    // const address1 = storeLocation.address;
    const handleSearchClick = (address1) => {
        const encodedAddress = encodeURIComponent(address1);
        const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
        window.open(googleMapsUrl, '_blank');
    };

    return (

        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{metaData?.meta_title ? metaData?.meta_title : "Wedding Day Diamonds"}</title>
                <meta
                    name="description"
                    content={metaData?.meta_desp}
                ></meta>
                <meta name="keywords" content={metaData?.meta_keywords}></meta>

  


            </Helmet>
            {storeLocation.map(stores =>
            (location1 === stores.location ?
                <section className='locationDetailPage'>
                    <div className='locationBanner lora' style={{ backgroundImage: `url(${banner})` }}>
                        <Container className='h-100'>
                            <Row className='align-items-center h-100'>
                                <Col md={6} lg={6}>
                                    <div className='textbox'>
                                        <h1>WEDDING DAY DIAMONDS <br />{stores.location}</h1>
                                        <p className='fontAvenir'>At Wedding Day Diamonds in {stores.location}, we are dedicated to helping you find the perfect jewelry for every special moment. Our store offers a stunning collection of engagement rings, wedding bands, fine jewelry, and more. We pride ourselves on providing exceptional customer service and a personalized shopping experience.</p>
                                        <Link to='/book-an-appointment' className='fontAvenir'>Book an Appointment</Link>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>

                    <div className='storeHours'>
                        <Container>
                            <h2 className='L_title lora'>STORE HOURS</h2>
                            <p className='L_text fontAvenir'>Our store is open to welcome you during the following hours:</p>
                            <Row>
                                <Col md={6}>
                                    <img alt={stores.location} src={stores.image} className='img-fluid pe-lg-5' />
                                </Col>
                                <Col md={6}>
                                    <div className='textbox'>
                                        <ul className='fontAvenir'>
                                            <li class="li-loc-hours"> <span>Monday:</span> 11:00 AM - 7:00 PM</li>
                                            <li class="li-loc-hours"> <span>Tuesday:</span> 11:00 AM - 7:00 PM</li>
                                            <li class="li-loc-hours"> <span>Wednesday:</span> 11:00 AM - 7:00 PM</li>
                                            <li class="li-loc-hours"> <span>Thursday:</span> 11:00 AM - 7:00 PM</li>
                                            <li class="li-loc-hours"> <span>Friday:</span> 11:00 AM - 7:00 PM</li>
                                            <li class="li-loc-hours"> <span>Saturday:</span> 10:00 AM - 6:00 PM</li>
                                            <li class="li-loc-hours"> <span>Sunday:</span> Closed</li>
                                        </ul>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>

                    <div className='visitUs'>
                        <Container>
                            <h2 className='L_title lora'>VISIT US</h2>
                            <p className='L_text fontAvenir'>Our location in {stores.location} makes it easy for you to visit and explore our store. We are committed to providing a welcoming and relaxed environment, where you can take your time to find the perfect piece of jewelry.</p>
                            <Row className='firstbox'>
                                <Col md={7}>
                                    <div className='textbox text-center'>
                                        <img src={Pin} alt='location' className='mb-3' />
                                        <h3 className='L_title lora'>WEDDING DAY DIAMONDS</h3>
                                        <p className='L_text fontAvenir text-white'>{stores.address}</p>
                                    </div>
                                </Col>
                                <Col md={5} className='text-end p-0'>
                                    <img src={visit} className='img-fluid' />
                                </Col>

                            </Row>
                            <p className='L_text fontAvenir mt-3 mb-4'>Ready to find your dream jewelry piece? Book a consultation with one of our expert jewelers today. We look forward to helping you celebrate your special moments with the perfect jewelry.</p>
                            <Row className='justify-content-center firstbox'>
                                <Col md={3} xs={8}>
                                    <Link to='/book-an-appointment'><img src={visit1} className='img-fluid' /></Link>
                                </Col>
                                <Col md={3} xs={8}>
                                    <a href={`tel:${stores.phone}`}><img src={visit2} className='img-fluid' /></a>
                                </Col>
                                <Col md={3} xs={8}>
                                    <span style={{ cursor: 'pointer' }} onClick={() => handleSearchClick(stores.address)}><img src={visit3} className='img-fluid' /></span>
                                </Col>
                            </Row>
                        </Container>
                    </div>

                    <div className='contactus mb-4'>
                        <Container>
                            <Row>
                                <Col md={3} className='ps-0'>
                                    <img src={contact} className='img-fluid' />
                                </Col>
                                <Col md={9}>
                                    <div className='textbox'>
                                        <h2 className='L_title lora text-start'>CONTACT US</h2>
                                        <p className='L_text fontAvenir text-start mb-3'>For any questions or to schedule a consultation, please contact us:</p>
                                        <p className='fontAvenir L_text text-start'> <span>- Phone:</span><a href={`tel:${stores.phone}`}>{stores.phone}</a></p>
                                        <p className='fontAvenir L_text text-start'> <span>- Email:</span> <a href={`mailto:${stores.location_email}`}>{stores.location_email}</a></p>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </section> : '')
            )}
        </>

    )
}

export default Index